import ErrorFallback from 'common/ErrorFallback'

// Type any is intentional here
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const withErrorBoundary = <P,>(
  WrappedComponent: React.FC<P>,
  errorMessage = ''
): React.FC<P> => {
  const WrappedErrorBoundaryComponent = (props) => {
    const isErrorTrackingEnabled =
      !!process.env.NEXT_PUBLIC_DATADOG_APP_ID &&
      !!process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
    return (
      <ErrorFallback
        shouldLogError={isErrorTrackingEnabled}
        message={errorMessage}
      >
        <WrappedComponent {...props} />
      </ErrorFallback>
    )
  }

  return WrappedErrorBoundaryComponent
}

export default withErrorBoundary
